import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import IndividualLearningCoursePerformance from "./routes/IndividualLearningCoursePerformance";

export default store => {
  return {
    path: "learning-course",
    component: withAsyncRouteLoading(() =>
      Promise.all([
        import(/* webpackChunkName: "learning-course" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    ),
    childRoutes: [IndividualLearningCoursePerformance(store)],
  };
};
